<template><div><h1>VUX V2.1.1Rc.3 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持字体变量 #990 @wg5945</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复 node 列表没有 forEach 方法 #991 @howyhuang</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[fix] 修复单独引入没有引入Loading组件时，样式缺失 #986 @malaimoo</li>
</ul>
<h2><a href="/zh-CN/components/ajax.html">Ajax</a></h2>
<ul><li>[feature] 支持通过 Vue.http 调用</li>
</ul>
<h2><a href="/zh-CN/components/wechat.html">Wechat</a></h2>
<ul><li>[feature] 支持通过 Vue.wechat 调用</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.3-218.vue?68b13a80